import type { Webhook } from '@/types'

const now = Date.now()
const day = 86_400_000

export const webhooks: Record<string, Webhook[]> = {
  's1': [
    { id: 'wh1', name: 'GitHub Bot', channelId: 'ch5', url: 'https://arcus.space/api/webhooks/wh1/abc123', createdBy: 'u1', createdAt: now - 14 * day },
    { id: 'wh2', name: 'Deploy Notifier', channelId: 'ch2', url: 'https://arcus.space/api/webhooks/wh2/def456', createdBy: 'u1', createdAt: now - 10 * day },
    { id: 'wh3', name: 'RSS Feed', channelId: 'ch3', url: 'https://arcus.space/api/webhooks/wh3/ghi789', createdBy: 'u2', createdAt: now - 7 * day },
  ],
  's2': [
    { id: 'wh4', name: 'Crates.io Tracker', channelId: 'ch8', url: 'https://arcus.space/api/webhooks/wh4/jkl012', createdBy: 'u4', createdAt: now - 30 * day },
    { id: 'wh5', name: 'Rustup Updates', channelId: 'ch8', url: 'https://arcus.space/api/webhooks/wh5/mno345', createdBy: 'u7', createdAt: now - 20 * day },
  ],
}
